import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Button, Navigation, Cell, Spacer, Text, Divider, Image, Icon } from '@vinted/web-ui';
import { ArrowLeft24, Dots24 } from '@vinted/monochrome-icons';
import { compact } from 'lodash';
import { produce } from 'immer';
import { ROOT_CATALOG_ID, WEB_CATALOG_ROOT_ALL_CODE } from 'constants/catalog';
import SelectableItemList from 'components/SelectableItemList';
import ScrollableArea from 'components/ScrollableArea';
import FilterDropdown from 'components/FilterDropdown';
import { getCatalogPhotoSrc } from 'data/utils/photo';
import { catalogsInAscOrder } from 'libs/utils/catalog';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DROPDOWN_MIN_WIDTH = 300;
const SELECT_DROPDOWN_MAX_HEIGHT = 320;
const ROOT_CATALOG_ALL_CODE = '_ALL_ROOT';

const catalogModelToCatalogListItem = catalog => {
  const {
    id,
    title,
    catalogIds,
    parentId,
    code,
    depth,
    itemCount,
    photo
  } = catalog;
  return {
    id,
    title,
    value: id,
    data: {
      id,
      catalogIds,
      parentId,
      code,
      depth,
      itemCount,
      photo
    }
  };
};

class CatalogFilter extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      navigatedCatalogId: ROOT_CATALOG_ID
    });

    _defineProperty(this, "translate", id => {
      const {
        intl
      } = this.props;
      return intl.formatMessage({
        id: "user.items.filters.catalog.".concat(id)
      });
    });

    _defineProperty(this, "getCatalogListItems", parentId => {
      const catalogList = this.getCatalogList(parentId);
      const catalogListItems = catalogList.map(catalogModelToCatalogListItem);

      if (parentId === ROOT_CATALOG_ID) {
        catalogListItems.unshift({
          id: ROOT_CATALOG_ID,
          title: this.translate('all'),
          value: ROOT_CATALOG_ID,
          data: {
            id: ROOT_CATALOG_ID,
            catalogIds: [],
            parentId: ROOT_CATALOG_ID,
            code: ROOT_CATALOG_ALL_CODE,
            depth: 0,
            itemCount: catalogList.reduce((acc, _ref) => {
              let {
                itemCount
              } = _ref;
              return acc + itemCount;
            }, 0),
            photo: null
          }
        });
      }

      return catalogListItems;
    });

    _defineProperty(this, "handleCatalogClick", catalog => {
      const {
        toggleCatalogFilterOption
      } = this.props;
      const data = catalog.data;

      if (data.catalogIds.length > 0 && data.code !== WEB_CATALOG_ROOT_ALL_CODE) {
        this.setState({
          navigatedCatalogId: Number(catalog.id)
        });
        return;
      }

      if (data.code === ROOT_CATALOG_ALL_CODE) {
        toggleCatalogFilterOption(null);
        return;
      }

      if (catalog.id) toggleCatalogFilterOption(Number(catalog.id));
    });

    _defineProperty(this, "handleBackClick", catalog => () => {
      this.setState({
        navigatedCatalogId: Number(catalog.parentId)
      });
    });

    _defineProperty(this, "renderCatalog", _ref2 => {
      let {
        item,
        itemElementProps
      } = _ref2;
      const data = item.data;
      const {
        catalogIds,
        code,
        depth,
        photo
      } = data;
      const icon = this.renderIcon(photo, code, depth);

      if (!catalogIds.length || code === WEB_CATALOG_ROOT_ALL_CODE) {
        return /*#__PURE__*/_jsx(Cell, _objectSpread(_objectSpread({}, itemElementProps), {}, {
          prefix: icon,
          suffix: /*#__PURE__*/_jsxs("div", {
            className: "u-flexbox u-align-items-center",
            children: [data.itemCount, /*#__PURE__*/_jsx(Spacer, {
              orientation: Spacer.Orientation.Vertical
            }), itemElementProps.suffix]
          })
        }));
      }

      return /*#__PURE__*/_jsx(Cell, _objectSpread(_objectSpread({}, itemElementProps), {}, {
        prefix: icon,
        suffix: data.itemCount,
        chevron: true
      }));
    });

    _defineProperty(this, "renderIcon", (photo, code, depth) => {
      if (depth > 1) return null;
      if (code === WEB_CATALOG_ROOT_ALL_CODE || code === ROOT_CATALOG_ALL_CODE) return /*#__PURE__*/_jsx(Icon, {
        name: Dots24,
        color: Icon.Color.Primary
      });
      if (!photo) return null;
      return /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, getCatalogPhotoSrc(photo)), {}, {
        size: Image.Size.Regular
      }));
    });
  }

  getCatalogList(parentId) {
    const {
      catalogs
    } = this.props;
    const parentCatalog = produce(catalogs.find(catalog => catalog.id === parentId), draft => {
      if (!draft) return;
      draft.title = this.translate('all');
      draft.code = WEB_CATALOG_ROOT_ALL_CODE; // 'All' catalog is placed alongside its children in the list.
      // Therefore, it must match children's depth.

      draft.depth += 1;
    });
    return compact([parentCatalog, ...catalogs.filter(catalog => catalog.parentId === parentId).sort(catalogsInAscOrder)]);
  }

  getSelectedName() {
    const {
      selectedId,
      catalogs
    } = this.props;
    if (!selectedId) return this.translate('all');
    const selectedCatalog = catalogs.find(_ref3 => {
      let {
        id
      } = _ref3;
      return id === selectedId;
    });
    return selectedCatalog ? selectedCatalog.title : '';
  }

  renderNavigation() {
    const {
      navigatedCatalogId
    } = this.state;
    const {
      catalogs
    } = this.props;
    const catalog = catalogs.find(_ref4 => {
      let {
        id
      } = _ref4;
      return id === navigatedCatalogId;
    });
    if (!catalog) return null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Navigation, {
        left: /*#__PURE__*/_jsx(Button, {
          styling: Button.Styling.Flat,
          theme: "amplified",
          icon: /*#__PURE__*/_jsx(Icon, {
            name: ArrowLeft24
          }),
          onClick: this.handleBackClick(catalog),
          testId: "catalog-filter-go-back"
        }),
        body: catalog.title
      }), /*#__PURE__*/_jsx(Divider, {})]
    });
  }

  renderDropdown() {
    const {
      selectedId
    } = this.props;
    const {
      navigatedCatalogId
    } = this.state;
    const items = this.getCatalogListItems(navigatedCatalogId);
    const selected = selectedId === null ? [-1] : [selectedId];
    return /*#__PURE__*/_jsxs("div", {
      className: "u-ui-padding-vertical-x-small",
      children: [this.renderNavigation(), /*#__PURE__*/_jsx(ScrollableArea, {
        maxHeight: SELECT_DROPDOWN_MAX_HEIGHT,
        children: /*#__PURE__*/_jsx(SelectableItemList, {
          name: "catalog_ids",
          isMultiSelect: false,
          items: items,
          selected: selected,
          onItemClick: this.handleCatalogClick,
          renderItem: this.renderCatalog
        })
      })]
    });
  }

  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "u-flexbox u-align-items-center",
      children: [/*#__PURE__*/_jsx(Text, {
        theme: "amplified",
        type: Text.Type.Subtitle,
        text: this.translate('name')
      }), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical
      }), /*#__PURE__*/_jsx(FilterDropdown, {
        title: this.getSelectedName(),
        minWidth: DROPDOWN_MIN_WIDTH,
        placement: "bottom-end",
        children: this.renderDropdown()
      })]
    });
  }

}

export default injectIntl(CatalogFilter);